import {createAction} from 'redux-actions';
import {
  SHOW_OVERLAYING_MODAL,
  HIDE_OVERLAYING_MODAL
} from '../config/const';

export const hideModal = createAction(HIDE_OVERLAYING_MODAL);
export const showModal = createAction(SHOW_OVERLAYING_MODAL);

const initialState = {
  visible: false
};
const overlayingModalReducer = (state = initialState, action) => {
  switch (action.type) {
  case SHOW_OVERLAYING_MODAL: {
    if (action.payload.modalProps) {
      return {
        visible: true,
        ...action.payload.modalProps,
      };
    }
    return {
      visible: true,
    };
  }
  case HIDE_OVERLAYING_MODAL: {
    return initialState;
  }
  default: {
    return state;
  }
  }
};

export default overlayingModalReducer;



// WEBPACK FOOTER //
// ./src/reducers/overlayingModalReducer.js